import { AnyAction } from "redux";
import { Indexes } from "../../types";
import { getSuccessActionType } from "../get-action-types";

function getIndexesReducer<T extends string>(type: T) {
  return function indexesReducer(state: Indexes = {}, action: AnyAction): Indexes {
    const data = action.payload;
    switch (action.type) {
      case getSuccessActionType(type):
        var indexes: Indexes = {};
        for (var i = 0; i < data.length; i++) {
          indexes[data[i].id] = i;
        }
        return indexes;
      default:
        return state;
    }
  };
}

export default getIndexesReducer;
